// extracted by mini-css-extract-plugin
module.exports = {"container":"c6e8ba5398--container--2y6aS","location_icon":"c6e8ba5398--location_icon--1ENUe","link":"c6e8ba5398--link--1m546"};